import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

const BACKEND = process.env.REACT_APP_BACKEND_URL ?? 'http://localhost:8001';

export default function AffiliatePage() {
  const { code } = useParams();

  useEffect(() => {
    window.location.href = `${BACKEND}/api/affiliate/go/${code}`;
  }, [code]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center">
      <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mb-4" />
      <p className="text-gray-600">Mengarahkan...</p>
    </div>
  );
}
